/**
 * Jméno modulu bridge. Slouží pro jednoznačnou identifikaci modulu.
 */
export const NAME = "bridge";

/**
 * Pomocná funkce pro vytvoření typu akce
 * @param actionType Typ akce
 */
const createActionType = (actionType: string) => `${NAME}/${actionType}`;

/** Konstanty typů akcí */
// Commons
export const SET_LOCAL_STORAGE_KEY = createActionType("SET_LOCAL_STORAGE_KEY");
export const LOAD_LOCAL_STORAGE_KEY = createActionType("LOAD_LOCAL_STORAGE_KEY");
export const LOCAL_STORAGE_KEY_LOADED = createActionType("LOCAL_STORAGE_KEY_LOADED");
export const LOAD_USER_INFO = createActionType("LOAD_USER_INFO");
export const USER_INFO_LOADED = createActionType("USER_INFO_LOADED");
export const SHOW_LOADING_INDICATOR = createActionType("SHOW_LOADING_INDICATOR");
export const HIDE_LOADING_INDICATOR = createActionType("HIDE_LOADING_INDICATOR");
export const LOGOUT = createActionType("LOGOUT");
export const APPLY_THEME = createActionType("APPLY_THEME");
// Localizations
export const LOAD_LOCALIZATION_ITEMS = createActionType("LOAD_LOCALIZATION_ITEMS");
export const LOCALIZATION_ITEMS_LOADED = createActionType("LOCALIZATION_ITEMS_LOADED");
// Forms
export const OPEN_FORM = createActionType("OPEN_FORM");
export const OPEN_FORM_MODAL = createActionType("OPEN_FORM_MODAL");
export const FORM_OPENED = createActionType("FORM_OPENED");
export const SWITCH_TO_FORM = createActionType("SWITCH_TO_FORM");
export const FORM_SWITCHED = createActionType("FORM_SWITCHED");
export const CLOSE_FORM = createActionType("CLOSE_FORM");
export const FORM_CLOSED = createActionType("FORM_CLOSED");
export const FORM_OVERLAY_CLICKED = createActionType("FORM_OVERLAY_CLICKED");
export const SHOW_FORM_OVERLAY = createActionType("SHOW_FORM_OVERLAY");
export const HIDE_FORM_OVERLAY = createActionType("HIDE_FORM_OVERLAY");
export const FORM_ITEM_INSTANCE_CLOSE_RESTRICTIONS_UPDATED = createActionType("FORM_ITEM_INSTANCE_CLOSE_RESTRICTIONS_UPDATED");
export const FORM_CUSTOM_TITLE_CHANGED = createActionType("FORM_CUSTOM_TITLE_CHANGED");
export const FORM_PROFILE_CHANGED = createActionType("FORM_PROFILE_CHANGED");
export const SELECTED_PROFILE_CHANGED = createActionType("SELECTED_PROFILE_CHANGED");
export const LOAD_HISTORY_FORMS_INFO = createActionType("LOAD_HISTORY_FORMS_INFO");
export const HISTORY_FORMS_INFO_UPDATED = createActionType("HISTORY_FORMS_INFO_UPDATED");
export const LOAD_FAVORITE_FORMS = createActionType("LOAD_FAVORITE_FORMS");
export const FAVORITE_FORMS_LOADED = createActionType("FAVORITE_FORMS_LOADED");
export const FAVORITE_FORM_UPDATED = createActionType("FAVORITE_FORM_UPDATED");
export const SET_FORM_AS_FAVORITE_REQUEST = createActionType("SET_FORM_AS_FAVORITE_REQUEST");
export const HIDE_ALL_FORMS = createActionType("HIDE_ALL_FORMS");
// Frames
export const EXECUTE_REACT_CONNECTOR_ACTION = createActionType("EXECUTE_REACT_CONNECTOR_ACTION");
export const SET_REACT_CONNECTOR_MULTISELECT_MODE = createActionType("SET_REACT_CONNECTOR_MULTISELECT_MODE");
// Main menu
export const LOAD_MENU_ITEMS = createActionType("LOAD_MENU_ITEMS");
export const MENU_ITEMS_LOADED = createActionType("MENU_ITEMS_LOADED");
export const LOAD_NOTIFICATION_ITEMS = createActionType("LOAD_NOTIFICATION_ITEMS");
export const NOTIFICATION_ITEMS_LOADED = createActionType("NOTIFICATION_ITEMS_LOADED");
export const LOAD_NOTIFICATION_GROUPS = createActionType("LOAD_NOTIFICATION_GROUPS");
export const NOTIFICATION_GROUPS_LOADED = createActionType("NOTIFICATION_GROUPS_LOADED");
export const SET_NOTIFICATION_ITEM_AS_READ = createActionType("SET_NOTIFICATION_ITEM_AS_READ");
export const SET_GROUP_NOTIFICATIONS_AS_READ = createActionType("SET_GROUP_NOTIFICATIONS_AS_READ");
export const TASK_RESULT_DETAIL_LOADED = createActionType("TASK_RESULT_DETAIL_LOADED");
export const LOAD_TASK_RESULT_DETAIL = createActionType("LOAD_TASK_RESULT_DETAIL");
export const SHOW_SETTINGS = createActionType("SHOW_SETTINGS");
export const MENU_ITEM_CUSTOM_ACTION_PROCESSED = createActionType("MENU_ITEM_CUSTOM_ACTION_PROCESSED");
export const PROCESS_MENU_ITEM_CUSTOM_ACTION = createActionType("PROCESS_MENU_ITEM_CUSTOM_ACTION");
